import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus-light",
  "use": "icon-plus-light-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plus-light\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 3C11.4477 3 11 3.44772 11 4V11H3.993C3.445 11 3 11.448 3 12C3 12.557 3.445 13 3.993 13H11V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V13H20.007C20.555 13 21 12.552 21 12C21 11.444 20.555 11 20.007 11H13V4C13 3.44772 12.5523 3 12 3Z\" fill=\"#BDBDBD\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol